import React, { useState, useEffect, useCallback } from 'react';
import { Button, Modal, Form, Input, message, Spin } from 'antd';
import { privacyService } from '../../services/privacyService';

const PrivacyManagement: React.FC = () => {
    const [privacy, setPrivacy] = useState<any>({});
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [loading, setLoading] = useState(false);

    const fetchPrivacy = useCallback(async () => {
        try {
            setLoading(true);
            const response = await privacyService.getPrivacy();
            if (response) {
                setPrivacy(response || {});
            } else {
                setPrivacy({});
            }
        } catch (error) {
            message.error('Không thể tải chính sách');
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchPrivacy();
    }, [fetchPrivacy]);

    const handleSubmit = async () => {
        try {
            if (privacy.id) {
                await privacyService.updatePrivacy(privacy);
                message.success('Cập nhật chính sách thành công');
            } else {
                await privacyService.createPrivacy(privacy);
                message.success('Tạo chính sách thành công');
            }
            setIsModalVisible(false);
            fetchPrivacy();
        } catch (error) {
            message.error('Không thể lưu chính sách');
        }
    };

    return (
        <div className="p-6">
            <div className="flex justify-between mb-4">
                <h1 className="text-2xl font-bold">Quản Lý Chính Sách</h1>
                <Button
                    type="primary"
                    onClick={() => setIsModalVisible(true)}
                >
                    {privacy.id ? 'Sửa Chính Sách' : 'Thêm Chính Sách'}
                </Button>
            </div>

            {loading ? (
                <div className="flex justify-center items-center h-screen">
                    <Spin size="large" />
                </div>
            ) : (
                <div className="bg-white p-4 rounded shadow">
                    <h2 className="text-lg font-semibold mb-2">Nội dung chính sách:</h2>
                    <div className="whitespace-pre-wrap">
                        {privacy?.content || 'Chưa có chính sách nào được tạo'}
                    </div>
                </div>
            )}

            <Modal
                title={privacy?.id ? 'Sửa Chính Sách' : 'Thêm Chính Sách'}
                visible={isModalVisible}
                onOk={handleSubmit}
                onCancel={() => setIsModalVisible(false)}
            >
                <Form layout="vertical">
                    <Form.Item label="Nội dung">
                        <Input.TextArea
                            rows={10}
                            value={privacy?.content}
                            onChange={(e) => setPrivacy({ ...privacy, content: e.target.value })}
                        />
                    </Form.Item>
                </Form>
            </Modal>
        </div>
    );
};

export default PrivacyManagement;